import React, {useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import {Grid} from '@mui/material';
import '../../globals/services-styles.css';
import {ContCampaignNotiPage, BtnOnbard, ContButton, IndentityPhoneImg, } from './CampaignNotiPage.styles';
import { IdentityCont, ContTextIdentity, TextIdentitySummary, ContCardIdentity, ContOnb, ContHowWork, TitleHowWork, ContTextDescHowWork, TextDescHowWork } from '../globalpages.styles';
import ButtonSpecial from '../../components/ButtonSpecial';
import ActionDemo from '../../components/ActionDemo/index';
import { CoreBancarioFAQ } from '../../components/CoreBancarioFAQ';
import phoneIdentity from '../../assets/images/Servicios/img-notificaciones.webp';
import StepsServices from '../../components/StepsServices/index';
import ServicesIntegrations from '../../components/ServicesIntegrations/index';
import ServicesBeneficios from '../../components/ServicesBeneficios/index';
import NotificationServices from '../../assets/images/Servicios/img-noti-beneficios.webp';
import msgImage from '../../assets/images/Servicios/msg-service.webp';
import SmsImage from '../../assets/images/Servicios/sms-service.webp';
import WhatsAppImage from '../../assets/images/Servicios/whatsapp-services.webp';

const CampaignNotiItems = [
  {
    title: 'Envío de mensajes masivos en cualquier momento',
  },
  {
    title: 'Facilidad de configuración y envío',
  },
  {
    title: 'Contacto directo con tus clientes',
  },
  {
    title: 'Campaña de cobranza',
  },
  {
    title: 'Notificaciones de pago automáticas',
  }
];
const stepsCampaignNoti = [
  { number: 1, title: 'Genera tu mensaje', subtitle: 'Crea una plantilla del mensaje que deas enviar.' },
  { number: 2, title: 'Medio de pago', subtitle: 'Determina el horario.' },
  { number: 3, title: 'Condiciones del mensaje', subtitle: 'Selecciona bajo que condiciones y perfil de cliente deseas enviar el mensaje.'},
  { number: 4, title: 'Envío exitoso', subtitle: 'Realiza el envío y tus clientes recibiran el mensaje en su dispositivo.' }
];

const notificacionesFaqData = [
  {
    id: 1,
    question: '¿Qué es el módulo de Campaña de Notificaciones?',
    answer: 'El módulo de Campaña de Notificaciones de Dynamicore permite enviar comunicaciones automatizadas y segmentadas a clientes a través de distintos canales, con el objetivo de impulsar acciones como pago, registro, actualización de datos o recordatorios. Está diseñado para mejorar la conversión, optimizar la cobranza y mantener comunicación directa con el cliente desde una sola plataforma.',
    relatedLinks: [
      {
        label: 'Estrategias de cobranza efectivas; campañas de mensajes automatizados',
        href: 'https://blog.dynamicore.io/b/estrategias-de-cobranza-efectivas-campanas-de-mensajes-automatizados/',
      },
    ],
  },
  {
    id: 2,
    question: '¿Se pueden personalizar los mensajes?',
    answerIntro: 'Sí. Dynamicore permite segmentar audiencias según criterios como:',
    answerList: [
      'Estatus de pago',
      'Días de atraso',
      'Tipo de producto',
      'Monto adeudado',
      'Fecha de vencimiento',
      'Segmento de riesgo',
      'Tipo de cliente (persona física o moral)',
    ],
    answerClosing: 'Esto permite enviar mensajes más personalizados y efectivos.',
  },
  {
    id: 3,
    question: '¿Se pueden automatizar recordatorios de pago?',
    answerIntro: 'El módulo permite configurar reglas automáticas para que los mensajes se envíen en función de eventos específicos, como:',
    answerList: [
      'Fecha próxima de vencimiento',
      'Pago no recibido',
      'Registro incompleto',
      'Desembolso realizado',
      'Activación de producto',
    ],
    answerClosing: 'La automatización reduce carga operativa y mejora la oportunidad de contacto.',
  },
  {
    id: 4,
    question: '¿Qué canales puedo utilizar para enviar mensajes?',
    answerIntro: 'Dependiendo de la configuración, las campañas pueden enviarse a través de:',
    answerList: [
      'SMS',
      'WhatsApp',
      'Correo electrónico',
    ],
    answerClosing: 'Esto permite elegir el canal más efectivo según el perfil del cliente.',
    relatedLinks: [
      {
        label: 'Estrategias de cobranza efectiva; campañas de mensajes automatizado',
        href: 'https://blog.dynamicore.io/b/estrategias-de-cobranza-efectivas-campanas-de-mensajes-automatizados/',
      },
    ],
  },
];

export const CampaignNotiPage = () => {
  const { t } = useTranslation();
  const imagesToShow = [
    { src: msgImage, visible: true, alt: 'Icono email', },
    { src: WhatsAppImage, visible: true, alt: 'Logo WhatsApp', },
    { src: SmsImage, visible: true, alt: 'Icono SMS', },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ContCampaignNotiPage id={'ContCampaignNotiPage'}>

      <ContCardIdentity id={'ContCardIdentity'}>
        <IdentityCont>
          <Grid container spacing={2} className={'ContCardIdentity GridBlueCard'}>
            <Grid item xs={12} sm={12} md={6} order={{ xs: 1, sm: 1, md: 1 }} style={{paddingLeft: '5%'}}>
              <ContOnb>
                <BtnOnbard>
                {t('Campaña de notificaciones')}
                </BtnOnbard>
              </ContOnb>
              <ContTextIdentity>
                {t('Crea una estrategia de comunicación con tus clientes')}
              </ContTextIdentity>
              <TextIdentitySummary>
                {t('Facilitamos la herramienta que te ayudará a mejorar el acercamiento con tus clientes a través de medios de mensajería directa.')}
              </TextIdentitySummary>
              <ContButton>
                <ButtonSpecial text={'Prueba la versión Demo'} type={'/'} linkTo={'/contacto'} target={'_self'} theme={'secondary'}/>
              </ContButton>
            </Grid>
            <Grid item xs={12} sm={12} md={6} 
              order={{ xs: 2, sm: 2, md: 2 }}
              className={'GridStylesCardImage'}
            >
              <IndentityPhoneImg src={phoneIdentity} alt={'Campaña de notificaciones Dynamicore'} visible={true} width={430}/>
            </Grid>
          </Grid>
        </IdentityCont>
      </ContCardIdentity>

      <ContHowWork id={'ContHowWork'}>
        <TitleHowWork>
          {t('¿Cómo funciona?')}
        </TitleHowWork>
        <ContTextDescHowWork>
          <TextDescHowWork>
            {t('Al generar y configurar tu campaña de notificaciones te comunicas de manera directa con tus clientes estableciendo bajo que condiciones se realiza el envío de mensajes SMS, Email y WhatsApp.')}
          </TextDescHowWork>
        </ContTextDescHowWork>

        <StepsServices steps={stepsCampaignNoti} version={2}/>
      
      </ContHowWork>

      <ServicesBeneficios items={CampaignNotiItems} image={NotificationServices} alt={'Recepción de mensaje automatizado'}/>

      <ServicesIntegrations imagesToShow={imagesToShow} text={'Utiliza distintos canales de comunicación con tus clientes.'}/>

      <CoreBancarioFAQ faqData={notificacionesFaqData} />

      <ActionDemo />
    </ContCampaignNotiPage>
  )
}
